import type { GameService } from './types'

const game: GameService = {
    name: 'cricket',
    category: 'classic',
    placeholder: true,
    disable: true,
    onlineAvailable: false,
    form: [
        {
            fields: [
                {
                    component: 'select',
                    key: 'win_type',
                    labelKey: 'match_settings.win_type_label',
                    options: [
                        { value: 'best_of', labelKey: 'match_settings.best_of' },
                        { value: 'first_to', labelKey: 'match_settings.first_to' },
                    ],
                },
                // The variant is stored as `lower_bound` (the lowest number in play,
                // 20 down to it plus Bull): Cricket plays 15-20, Tactics 10-20.
                {
                    component: 'select',
                    key: 'lower_bound',
                    labelKey: 'match_settings.variant',
                    divider: true,
                    options: [
                        { value: 15, labelKey: 'match_settings.variant_cricket' },
                        { value: 10, labelKey: 'match_settings.variant_tactics' },
                    ],
                },
                // "Include in stats" is rendered once, universally, by MatchSetupView's
                // static footer toggle — not per-game, so it isn't listed here.
            ],
        },
    ],
    content: {
        type: 'cricket',
        duration: [20, 40],
        difficulty: 'medium',
        player_count: '2 - 4',
    },
}

export default game
